<div class="navbar-policy__search">
  <div class="navbar-policy__search-trigger" id="search-trigger">
    <svg class="icon"><use xlink:href="#search-small"></use></svg>
  </div>
  <div class="navbar-policy__search-container" id="search-container">
    <div class="form-control__wrap has-clear">
      <input type="search" placeholder="Search" id="search-input" autocomplete="off" class="form-control form-control--sm" />

      <a href="#" id="search-clear" class="form-control__clear"><svg class="icon"><use xlink:href="#close-circle-small"></use></svg></a>
    </div>
    <div class="navbar-policy__search-up" title="Prev">
      <svg class="icon"><use xlink:href="#dropdown-up-medium"></use></svg>
    </div>
    <div class="navbar-policy__search-down" title="Next">
      <svg class="icon"><use xlink:href="#dropdown-down-medium"></use></svg>
    </div>
  </div>
</div>
